<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col">
                            <h3 class="mb-0">
                              Executar Pagamento de Procedimento
                            </h3>
                          </div>
                        </div>
                      </div>
                       <div class="text-right p-4">
                         
                       </div>
                      

                      <div class="table-responsive">
                        <template>
                          <base-table class="table align-items-center table-flush"
                                      tbody-classes="list"
                                      :data="listaDados">
                            <template slot="columns">
                              <th class="text-center">#</th>
                              <th>Protético</th>
                              <th>Paciente</th>
                              <th>Procedimento</th>
                               <th class="text-center">Data / Hora</th>
                               <th class="text-right">Valor Un.</th>
                               <th class="text-center">Quantidade</th>
                               <th class="text-right">Valor Total</th>
                              <th class="text-center">Data de Criação</th>
                            </template>

                            <template slot-scope="{row}">
                              <th scope="row">
                                <span>{{ row.id }}-{{ row.agenda_proc_id }}</span>
                              </th>
                              <td>
                                {{ row.protetico.nomeCompleto }}
                              </td>
                              <td>
                                {{ row.paciente }}
                              </td>
                              <td>
                                {{ row.nome }}
                              </td>
                              <th class="text-center">
                               {{ row.data }} {{ row.hora }}
                              </th>
                              <td class="text-right">
                                R$ {{ row.valor_un.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                              </td>
                              <td class="text-center">
                                {{ row.quant }}
                              </td>
                              <td class="text-right">
                                R$ {{ row.valor_tt.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                              </td>
                              <td  class="text-center">
                                <span class="name mb-0 text-sm"> {{formatarData(row.created_at)}}</span>
                              </td>
                            </template>

                          </base-table>
                        </template>
                      </div>

                      <template v-if="!loading">
                        <div class="protetico">
                          <div class="protetico__box">
                            <h1 class="protetico__head">
                              Dados para pagamento
                            </h1>

                            <ul class="protetico__data">
                              <li>Protético: <strong>{{ protetico.nomeCompleto }}</strong></li>
                              <li>Forma de Pagamento: <strong>PIX</strong></li>
                              <li>Tipo Pix: <strong>{{ protetico.pix_tipo }}</strong></li>
                              <li>Chave Pix: <strong>{{ protetico.pix_chave }}</strong></li>
                              <li>Valor a Depositar: <strong>R$ {{ valor_total.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}</strong></li>
                            </ul>
                          </div>

                          <div class="protetico__box">
                            <div class="uploader">
                              <label>
                                  <i class="ni ni-cloud-upload-96" />
                                  <span>Selecionar Comprovante</span>
                                  <input type="file" @change="processFiles" />
                              </label>

                              <ul class="uploader-list">
                                  <li v-for="(file, k) in filesArray" :key="k">{{file.name}}</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </template>

                       <template v-if="loading">
                          <div class="m-2">
                            <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                          </div>
                        </template>

                        <div slot="footer" class="caseSalvar d-center flex-row p-1 no-print mt-4 mb-4" v-if="!loading">
                          <base-button type="default" @click="uploadPagamento()" v-show="user.tipo === 'lab'">Salvar Comprovante</base-button>
                        </div>

                        <div class="erro" v-show="hasError">
                          <p>Houve um erro ao salvar seu comprovante, verifique o seu arquivo.</p>
                        </div>


                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import agenda from '@/cflow/agendaProtetica.js'
  import moment from 'moment';
  import BaseButton from '../../components/BaseButton.vue';
  //import BaseInput from '../../components/BaseInput.vue';
  //import Multiselect from "vue-multiselect";
  import storage from 'storage';
  import router from '@/router'
  export default {
    name: 'tables',
    components: {
     // Multiselect,
      BaseButton,
     // BaseInput
    },
    methods: {
      uploadPagamento() {

        const _this = this;
        const idxs = _this.$route.params.idxs;
        const files = _this.filesArray;
        const form = _this.formData;

        _this.hasError = false;
        _this.loading = true;

        agenda.upload(files).then( files_path => {

          if(files_path.data && files_path.data.length > 0) {
            form.arquivos = files_path.data;
          }

          form.protetico = _this.protetico.nomeCompleto;
          form.total = _this.valor_total;
          form.id_lab = _this.user.id;

          agenda.salvarPagamento(idxs, form).then(() => {
            router.push('/relatorio-procedimentos');
          }).catch(() => {
            _this.hasError = true;
            _this.loading = false;
          })

        })



        //router.push('/relatorio-servicos/pagamentos/' + idxs);

      },
      processFiles: function(event) {
      var files = event?.target?.files;
 
      if(files && files.length > 0) {
        this.filesArray = files;
      }
 
    },
      initLoad: function() {
        this.loading = true;
        const idxs = this.$route.params.idxs;
        Promise.all([agenda.listarServicosParaPagar(idxs)]).then( res => {
          this.listaDados = this.listaDados.concat(res[0]);
          this.protetico = this.listaDados[0].protetico;
          const _this = this;
          this.listaDados.forEach(item => {
            _this.valor_total += item.valor_tt;
          })
          this.loading = false;
         
        })
      }
    },
    watch: {
      
    },
    data() {
      return {
        loading: false,
        user: {},
        listaDados:[],
        protetico: {},
        valor_total: 0,
        filesArray: [],
        formData: {
          arquivos: null,
          protetico: null,
          total: null,
          id_lab: null
        },
        today: moment().format('YYYY-MM-DD'),
        hasError: false
      }
    },
    mounted(){
      this.user = storage.get("user");
      this.initLoad(0);
    }
  };
</script>
<style lang="scss" scoped>
.protetico {
  padding: 20px 20px;
  margin: 20px 20px;
  border: 1px solid #ccc;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.protetico__box {
  width: 50%;
}
.protetico__name {
  font-size: 16px;
}
.protetico__data {
  list-style: none;
  padding: 0;
}
.protetico__data li {
  font-size: 12px;
}
.protetico__data li strong {
  font-size: 14px;
}

@media all and (max-width: 630px) {
  .protetico {
    flex-direction: column;
  }
  .protetico__box {
    width: 100%;
    padding: 20px 0;
  }
}

.files {
  padding: 40px 0;
}
.uploader input {
  display: none;
}
.uploader label {
  cursor: pointer;
  text-align: center;
  border: 2px solid #525f7f;
  border-radius: 10px;
  padding: 10px 0;
  opacity: 0.8;
}
.uploader label:hover {
  opacity: 1;
}
.uploader i {
  width: 100%;
  font-size: 42px;
}
.uploader span {
  font-size: 14px;
  text-transform: uppercase;
}
.uploader-list {
  margin: 20px 0 0 0;
}

.erro {
  padding: 20px;
  font-size: 12px;
  text-transform: uppercase;
  color: red;
  text-align: center;
}
</style>
